import PropTypes from 'prop-types';

import EventInfoBody from './EventInfoBody';

const EventInfoView = ({ content, data }) => {
  return <EventInfoBody content={content} data={data} />;
};

EventInfoView.propTypes = {
  content: PropTypes.object,
  data: PropTypes.object,
};

export default EventInfoView;
